export default __webpack_public_path__ + "static/media/01-rock-dx.50e7bea7.png";